<template>
  <div class="navbar bg-neutral text-neutral-content">
    <router-link to="/" class="btn btn-ghost normal-case text-xl">expat.com</router-link>
  </div>
</template>

<script>
export default {
  name: "NavbarVue",
};
</script>

<style></style>
